import { memo } from 'react';
import { Box, Text } from '@bonanza-social/moonlight';
import StatusPerkUpgradeLabel from './StatusPerkUpgradeLabel/StatusPerkUpgradeLabel';
import StatusPerkMessage from './StatusPerkMessage';
import { StatusPerkProps } from './types';
import { statusPerkRewardTypeMap } from '../../content/perks.content';

function StatusPerk({
  perkType,
  upgradeType,
  currentStatus,
  nextStatus,
  nextStatusPerkAmount,
  currentStatusPerkAmount,
}: StatusPerkProps) {
  const perkRewardType = statusPerkRewardTypeMap[perkType];
  const backgroundStatusToken =
    nextStatus && upgradeType === 'ReachNextStatusToUnlock'
      ? nextStatus
      : currentStatus;

  return (
    <Box
      variant="gradient"
      gradient={`status${backgroundStatusToken}Background`}
      padding="space-200"
      gap="space-200"
      borderRadius="radius-300"
      alignItems="center"
      minWidth={120}
    >
      {/* dark overlay for locked perks */}
      {upgradeType === 'ReachNextStatusToUnlock' ? (
        <Box
          position="absolute"
          top="space-0"
          bottom="space-0"
          left="space-0"
          right="space-0"
          backgroundColor="tertiaryBackgroundHover"
          borderRadius="radius-300"
        />
      ) : null}
      <Box gap="space-100" alignItems="center">
        <Text
          variant="nav-label"
          color="accentSurfacePrimary"
          locNS="status"
          locKey={`perkTitle${perkType}`}
        />
        <StatusPerkMessage
          perkType={perkType}
          currentStatusPerkAmount={currentStatusPerkAmount}
          currentStatus={currentStatus}
          nextStatus={nextStatus}
          upgradeType={upgradeType}
        />
      </Box>
      <StatusPerkUpgradeLabel
        upgradeType={upgradeType}
        nextStatus={nextStatus}
        nextStatusPerkAmount={nextStatusPerkAmount}
        perkRewardType={perkRewardType}
      />
    </Box>
  );
}

export default memo(StatusPerk);
